import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../Context/api";
import Spinner from "../Helpers/Spinner";

function ResetPassword() {
  const { token } = useParams(); // Extract token from URL
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
      setMessageType("error");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await API.post("/auth/reset-password", {
        token,
        password,
      });
      setMessage(response.data.message);
      setMessageType("success");
      setTimeout(() => navigate("/login"), 5000); // Redirect after 5 seconds
    } catch (error) {
      setMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
      setMessageType("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Clear message after 5 seconds (unless redirecting)
  useEffect(() => {
    if (message && messageType !== "success") {
      const timer = setTimeout(() => {
        setMessage("");
        setMessageType("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, messageType]);

  return (
    // <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
    //   <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg">
    //     <h1 className="text-center text-3xl font-bold text-gray-900">
    //       Reset Password
    //     </h1>

    //     {message && (
    //       <div
    //         className={`text-center text-sm p-3 rounded-md ${
    //           messageType === "success"
    //             ? "bg-green-100 text-green-700"
    //             : "bg-red-100 text-red-700"
    //         }`}
    //       >
    //         {message}
    //       </div>
    //     )}

    //     <form onSubmit={handleResetPassword} className="space-y-6">
    //       <div>
    //         <label
    //           htmlFor="password"
    //           className="block text-sm font-medium text-gray-700 mb-1"
    //         >
    //           New Password
    //         </label>
    //         <input
    //           type="password"
    //           id="password"
    //           value={password}
    //           onChange={(e) => setPassword(e.target.value)}
    //           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //           placeholder="Enter your new password"
    //           required
    //           disabled={isSubmitting}
    //         />
    //       </div>
    //       <div>
    //         <label
    //           htmlFor="confirmPassword"
    //           className="block text-sm font-medium text-gray-700 mb-1"
    //         >
    //           Confirm Password
    //         </label>
    //         <input
    //           type="password"
    //           id="confirmPassword"
    //           value={confirmPassword}
    //           onChange={(e) => setConfirmPassword(e.target.value)}
    //           className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none"
    //           placeholder="Confirm your new password"
    //           required
    //           disabled={isSubmitting}
    //         />
    //       </div>
    //       <button
    //         type="submit"
    //         disabled={isSubmitting}
    //         className={`w-full py-2 rounded-md text-white font-medium transition duration-200 ${
    //           isSubmitting
    //             ? "bg-indigo-300 cursor-not-allowed"
    //             : "bg-indigo-600 hover:bg-indigo-700"
    //         }`}
    //       >
    //         {isSubmitting ? "Resetting..." : "Reset Password"}
    //       </button>
    //     </form>
    //   </div>
    // </div>
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-8 px-4 sm:px-6 lg:px-8">
      {isSubmitting && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-opacity-50 bg-gray-100 z-10">
          <Spinner />
        </div>
      )}
      <div className="w-full max-w-xs sm:max-w-sm md:max-w-md space-y-6 bg-white p-6 sm:p-8 rounded-xl shadow-lg">
        <h1 className="text-center text-xl sm:text-2xl md:text-3xl font-bold text-gray-900">
          Reset Password
        </h1>

        {message && (
          <div
            className={`text-center text-xs sm:text-sm md:text-base p-2 sm:p-3 rounded-md ${
              messageType === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message}
          </div>
        )}

        <form onSubmit={handleResetPassword} className="space-y-4 sm:space-y-6">
          <div>
            <label
              htmlFor="password"
              className="block text-xs sm:text-sm md:text-base font-medium text-gray-700 mb-1 sm:mb-2"
            >
              New Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none placeholder:text-gray-400"
              placeholder="Enter your new password"
              required
              disabled={isSubmitting}
            />
          </div>
          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-xs sm:text-sm md:text-base font-medium text-gray-700 mb-1 sm:mb-2"
            >
              Confirm Password
            </label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full px-3 sm:px-4 py-1.5 sm:py-2 text-xs sm:text-sm md:text-base border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:outline-none placeholder:text-gray-400"
              placeholder="Confirm your new password"
              required
              disabled={isSubmitting}
            />
          </div>
          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full py-1.5 sm:py-2 text-xs sm:text-sm md:text-base rounded-md text-white font-medium transition duration-200 ${
              isSubmitting
                ? "bg-indigo-300 cursor-not-allowed"
                : "bg-indigo-600 hover:bg-indigo-700"
            }`}
          >
            {isSubmitting ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
